import React, { useState } from 'react';
import useFetch from 'use-http';
import * as styles from './styles';
import { ILeaseRecordsApiError, LeaseRecordsErrorAlert, parseLeaseRecordsApiError } from '../LeaseRecordsApiError';

interface ILessorCsvDownloadButtonProps {
    liTg?: number;
}

const LessorCsvDownloadButton: React.FC<ILessorCsvDownloadButtonProps> = ({ liTg }) => {
    const { get, response } = useFetch();
    const [isDownloading, setIsDownloading] = useState(false);
    const [requestError, setRequestError] = useState<ILeaseRecordsApiError | null>(null);
    const canDownload = !!liTg && liTg > 0;

    const download = async (): Promise<void> => {
        if (!canDownload || !liTg) {
            alert('Save the invoice before downloading the Lessor data file.');
            return;
        }

        setIsDownloading(true);
        setRequestError(null);
        try {
            await get(`/v1.0/leases/invoices/lessor-csv/report?liTg=${liTg}`);
            if (!response.ok) {
                const message = await response.text();
                setRequestError(
                    parseLeaseRecordsApiError(response.data || message || { title: 'Failed to generate the Lessor data file.' }, response.status)
                );
                return;
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = 'LeaseLessor.txt';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            setRequestError(
                parseLeaseRecordsApiError({ title: 'The Lessor data file could not be downloaded. Please try again or contact support.' }, 500)
            );
        } finally {
            setIsDownloading(false);
        }
    };

    const unavailableMessage = canDownload ? undefined : 'Save the invoice to assign an LI_TG before downloading.';

    return (
        <>
            <button
                type="button"
                style={{
                    ...styles.buttonSecondary,
                    opacity: !canDownload || isDownloading ? 0.7 : 1,
                    cursor: !canDownload || isDownloading ? 'not-allowed' : 'pointer',
                }}
                disabled={!canDownload || isDownloading}
                title={unavailableMessage}
                onClick={(event) => {
                    event.stopPropagation();
                    void download();
                }}
            >
                Lessor.txt
            </button>
            <LeaseRecordsErrorAlert error={requestError} onDismiss={() => setRequestError(null)} />
        </>
    );
};

export default LessorCsvDownloadButton;



// WEBPACK FOOTER //
// ./src/components/leases/sections/LessorCsvDownloadButton.tsx